import {AIP, matchAIPByType} from 'ApplicationEntry/models/ProductsRiders/AIP/AIP';
import * as G from 'ApplicationEntry/models/ProductsRiders/AIP/GroupAIP';
import * as NY from 'ApplicationEntry/models/ProductsRiders/AIP/NewYorkAIP';
import * as O from 'ApplicationEntry/models/ProductsRiders/AIP/OrdinaryAIP';
import {Async, Loading} from 'Core/models/Async';
import {createAction} from 'Shared/utilities/actionCreator';
import {reverseEnum} from 'Shared/utilities/enumUtility';

export enum AIPActionType {
  CHANGE_IND_WEEKLY_PREMIUM = 'aip/CHANGE_IND_WEEKLY_PREMIUM',
  CHANGE_FAMILY_WEEKLY_PREMIUM = 'aip/CHANGE_FAMILY_WEEKLY_PREMIUM',
  CHANGE_IND_MONTHLY_PREMIUM = 'aip/CHANGE_IND_MONTHLY_PREMIUM',
  CHANGE_FAMILY_MONTHLY_PREMIUM = 'aip/CHANGE_FAMILY_MONTHLY_PREMIUM',
  CHANGE_PREMIUM = 'aip/CHANGE_PREMIUM',
  CHANGE_CALCULATED_PREMIUM = 'aip/CHANGE_CALCULATED_PREMIUM',
  CHANGE_CWA = 'aip/CHANGE_CWA',
  CHANGE_UNITS = 'aip/CHANGE_UNITS',
  CHANGE_SECTION125 = 'aip/CHANGE_SECTION125',
  CHANGE_PACKAGE = 'aip/CHANGE_PACKAGE',
  CHANGE_SITUS = 'aip/CHANGE_SITUS',
  CHANGE_JSTAMP = 'aip/CHANGE_JSTAMP',
  GET_PACKAGE_LIST = 'aip/GET_PACKAGE_LIST',
  CHANGE_PACKAGE_LIST = 'aip/CHANGE_PACKAGE_LIST',
  CHANGE_PLAN_TYPE = 'aip/CHANGE_PLAN_TYPE',
  CLEAR_AIP = 'aip/CLEAR_AIP',
}

export const isAIPAction = (action: any): action is AIPAction => action.type in reverseEnum(AIPActionType);

export const changePlanType = (planType: string) => createAction(AIPActionType.CHANGE_PLAN_TYPE, {planType});
export const changeIndWeeklyPremium = (indWeeklyPremium: string) =>
  createAction(AIPActionType.CHANGE_IND_WEEKLY_PREMIUM, {indWeeklyPremium});
  export const changeFamilyWeeklyPremium = (familyWeeklyPremium: string) =>
    createAction(AIPActionType.CHANGE_FAMILY_WEEKLY_PREMIUM, {familyWeeklyPremium});
export const changeIndMonthlyPremium = (indMonthlyPremium: string) =>
  createAction(AIPActionType.CHANGE_IND_MONTHLY_PREMIUM, {indMonthlyPremium});
  export const changeFamilyMonthlyPremium = (familyMonthlyPremium: string) =>
    createAction(AIPActionType.CHANGE_FAMILY_MONTHLY_PREMIUM, {familyMonthlyPremium});
export const changePremium = (premium: string) => createAction(AIPActionType.CHANGE_PREMIUM, {premium});
export const changeCalculatedPremium = (calculatedPremium: string) =>
  createAction(AIPActionType.CHANGE_CALCULATED_PREMIUM, {calculatedPremium});
export const changeCWA = (cwa: string) => createAction(AIPActionType.CHANGE_CWA, {cwa});
export const changeUnits = (units: string) => createAction(AIPActionType.CHANGE_UNITS, {units});
export const changeSection125 = (section125: boolean) => createAction(AIPActionType.CHANGE_SECTION125, {section125});
export const changePackage = (packageOpt: string) => createAction(AIPActionType.CHANGE_PACKAGE, {packageOpt});
export const changeSitus = (situs: string) => createAction(AIPActionType.CHANGE_SITUS, {situs});
export const changeJStamp = (stamp: boolean) => createAction(AIPActionType.CHANGE_JSTAMP, {stamp});
export const getPackages = (planCode: string, caseNumber: string) =>
  createAction(AIPActionType.GET_PACKAGE_LIST, {planCode, caseNumber});
export const changePackageList = (packages: Async<object[]>) =>
  createAction(AIPActionType.CHANGE_PACKAGE_LIST, {packages});
export const clearAIP = () => createAction(AIPActionType.CLEAR_AIP);

export type AIPAction =
  | ReturnType<typeof changePremium>
  | ReturnType<typeof changeIndWeeklyPremium>
  | ReturnType<typeof changeFamilyWeeklyPremium>
  | ReturnType<typeof changeIndMonthlyPremium>
  | ReturnType<typeof changeFamilyMonthlyPremium>
  | ReturnType<typeof changeCalculatedPremium>
  | ReturnType<typeof changeCWA>
  | ReturnType<typeof changeUnits>
  | ReturnType<typeof changeSection125>
  | ReturnType<typeof changePackage>
  | ReturnType<typeof changeSitus>
  | ReturnType<typeof changeJStamp>
  | ReturnType<typeof getPackages>
  | ReturnType<typeof changePackageList>
  | ReturnType<typeof changePlanType>
  | ReturnType<typeof clearAIP>;

type AIPState = AIP;

export default (state: AIPState, action: AIPAction): AIPState => {
  switch (action.type) {
    case AIPActionType.CHANGE_PLAN_TYPE:
      return matchAIPByType<AIP>({
        Ordinary: O.changePlanType(action.payload.planType),
        Group: G.changePlanType(action.payload.planType),
        NewYork: NY.changePlanType(action.payload.planType),
      })(state);
    case AIPActionType.CHANGE_IND_WEEKLY_PREMIUM:
      return matchAIPByType<AIP>({
        Ordinary: O.changeIndWeeklyPremium(action.payload.indWeeklyPremium),
        Group: G.changeIndWeeklyPremium(action.payload.indWeeklyPremium),
        NewYork: NY.changeIndWeeklyPremium(action.payload.indWeeklyPremium),
      })(state);
      case AIPActionType.CHANGE_FAMILY_WEEKLY_PREMIUM:
        return matchAIPByType<AIP>({
          Ordinary: O.changeFamilyWeeklyPremium(action.payload.familyWeeklyPremium),
          Group: G.changeFamilyWeeklyPremium(action.payload.familyWeeklyPremium),
          NewYork: NY.changeFamilyWeeklyPremium(action.payload.familyWeeklyPremium),
        })(state);
    case AIPActionType.CHANGE_IND_MONTHLY_PREMIUM:
      return matchAIPByType<AIP>({
        Ordinary: O.changeIndMonthlyPremium(action.payload.indMonthlyPremium),
        Group: G.changeIndMonthlyPremium(action.payload.indMonthlyPremium),
        NewYork: NY.changeIndMonthlyPremium(action.payload.indMonthlyPremium),
      })(state);
      case AIPActionType.CHANGE_FAMILY_MONTHLY_PREMIUM:
        return matchAIPByType<AIP>({
          Ordinary: O.changeFamilyMonthlyPremium(action.payload.familyMonthlyPremium),
          Group: G.changeFamilyMonthlyPremium(action.payload.familyMonthlyPremium),
          NewYork: NY.changeFamilyMonthlyPremium(action.payload.familyMonthlyPremium),
        })(state);
    case AIPActionType.CHANGE_PREMIUM:
      return matchAIPByType<AIP>({
        Ordinary: O.changePremium(action.payload.premium),
        Group: G.changePremium(action.payload.premium),
        NewYork: NY.changePremium(action.payload.premium),
      })(state);
    case AIPActionType.CHANGE_CALCULATED_PREMIUM:
      return matchAIPByType<AIP>({
        Ordinary: O.changeCalculatedPremium(action.payload.calculatedPremium),
        Group: G.changeCalculatedPremium(action.payload.calculatedPremium),
        NewYork: NY.changeCalculatedPremium(action.payload.calculatedPremium),
      })(state);
    case AIPActionType.CHANGE_CWA:
      return matchAIPByType<AIP>({
        Ordinary: O.changeCWA(action.payload.cwa),
        Group: G.changeCWA(action.payload.cwa),
        NewYork: NY.changeCWA(action.payload.cwa),
      })(state);
    case AIPActionType.CHANGE_UNITS:
      return matchAIPByType<AIP>({
        Ordinary: O.changeUnits(action.payload.units),
        Group: G.changeUnits(action.payload.units),
        NewYork: NY.changeUnits(action.payload.units),
      })(state);
    case AIPActionType.CHANGE_SECTION125:
      return matchAIPByType<AIP>({
        Ordinary: O.changeSection(action.payload.section125),
        Group: G.changeSection(action.payload.section125),
        NewYork: NY.changeSection(action.payload.section125),
      })(state);
    case AIPActionType.CHANGE_PACKAGE:
      return matchAIPByType<AIP>({
        Ordinary: O.changePackage(action.payload.packageOpt),
        Group: G.changePackage(action.payload.packageOpt),
        NewYork: NY.changePackage(action.payload.packageOpt),
      })(state);
    case AIPActionType.CHANGE_SITUS:
      return matchAIPByType<AIP>({
        Ordinary: O.changeSitus(action.payload.situs),
        Group: G.changeSitus(action.payload.situs),
        NewYork: NY.changeSitus(action.payload.situs),
      })(state);
    case AIPActionType.CHANGE_JSTAMP:
      return matchAIPByType<AIP>({
        Ordinary: O.changeJStamp(action.payload.stamp),
        Group: G.changeJStamp(action.payload.stamp),
        NewYork: NY.changeJStamp(action.payload.stamp),
      })(state);
    case AIPActionType.GET_PACKAGE_LIST:
      return matchAIPByType<AIP>({
        Group: G.changePackageList(new Loading()),
        Ordinary: O.changePackageList(new Loading()),
        NewYork: NY.changePackageList(new Loading()),
      })(state);
    case AIPActionType.CHANGE_PACKAGE_LIST:
      return matchAIPByType<AIP>({
        Group: G.changePackageList(action.payload.packages),
        Ordinary: O.changePackageList(action.payload.packages),
        NewYork: NY.changePackageList(action.payload.packages),
      })(state);
    case AIPActionType.CLEAR_AIP: {
      if (state.key === 'InvalidGroupAIP' || state.key === 'ValidGroupAIP') {
        return G.EmptyGroupAIP;
      }
      return state;
    }
    default:
      return state;
  }
};
